import { Component, OnInit } from '@angular/core';
// import { data } from './masterClassJson'
import { GlobalService } from 'src/app/services/global.service';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { time } from 'console';


@Component({
  selector: 'sd-masterclass',
  templateUrl: './masterclass.component.html',
  styleUrls: ['./masterclass.component.scss']
})
export class MasterclassComponent implements OnInit {
  data :any;
  codeCopied = [];
 slug= '';
  isLoading: boolean = true;

  constructor( public global: GlobalService,
      public user: UserService,
      public dialog: DialogService,
      private router: Router,
      private http: HttpClient,
    private route: ActivatedRoute) { 

    }

  ngOnInit(): void {
    this.route.params.subscribe(res => {
      this.slug = res.slug;
    })
      const timestamp = new Date().getTime();
      const url = `../../../assets/Json/masterClassJson.json?t=${timestamp}`;
      this.http.get(url).subscribe(data => {
      this.isLoading = false;
      this.data = data;
      this.data.masterClasses.sort((a,b)=> Number(a.ended) - Number(b.ended));
      this.couponCodes();
      this.calculateRemainingTime(this.data.masterClasses);
});
     
  }

  couponCodes(){
    this.data.couponCodes.forEach((item,index)=>{
      this.codeCopied[index]=false;
    })
  }

  calculateRemainingTime(masterClasses: any[]): any[] {
    const currentTime = new Date(); // Current date and time
    return masterClasses.map((masterClass) => {
      if (!masterClass.ended && !masterClass.startingSoon ) {
        const dateTimeParts = masterClass.date.split(" at "); // Split the date and time
        const dateParts = dateTimeParts[0].split("/"); // Split the date into day, month, year
        const timeParts = dateTimeParts[1].split(/[: ]/); // Split the time into hours, minutes, and period (AM/PM)
  
        // Convert to 24-hour format
        let hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const period = timeParts[2]; // AM or PM
        if (period === "PM" && hours !== 12) {
          hours += 12;
        } else if (period === "AM" && hours === 12) {
          hours = 0;
        }
  
        // Create a new Date object
        const classDate = new Date(
          parseInt(dateParts[2], 10), // Year
          parseInt(dateParts[1], 10) - 1, // Month (0-based index)
          parseInt(dateParts[0], 10), // Day
          hours,
          minutes
        );
  
        let durationInMinutes = 0;
        const durationMatch = masterClass.duration.match(/(\d+)\s*(hours|hour|mins|minute|min)/i);
        if (durationMatch) {
          const number = parseInt(durationMatch[1], 10);
          const unit = durationMatch[2].toLowerCase();
    
          if (unit === "hour" || unit === "hours") {
            durationInMinutes = number * 60; // Convert hours to minutes
          } else if (unit === "minute" || unit === "mins" || unit === "min") {
            durationInMinutes = number; // Duration in minutes
          }
        }
    
        // Calculate the class end time by adding the duration to the start time
        const classEndTime = new Date(classDate.getTime() + durationInMinutes * 60 * 1000);
    


        // Calculate time difference
        // console.log("ct cd",currentTime,classDate);
        if (currentTime > classEndTime) {
          masterClass.ended = true;
          masterClass.startingSoonTime = "Class has ended";
        } else if (currentTime > classDate) {
          masterClass.startingSoonTime = "Class is ongoing";
        }else {

          const timeDifference = classDate.getTime() - currentTime.getTime();
          const hoursDiff = Math.floor(timeDifference / (1000 * 60 * 60));
          const minutesDiff = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          // console.log("hoursDiff",hoursDiff)
          if(hoursDiff > 0){
            hoursDiff <= 24 ? masterClass.startingSoonTime = `Starting in ${hoursDiff} hours` : '';
          }else if(minutesDiff > 0 && minutesDiff <=60 ){
            masterClass.startingSoonTime = `Starting in ${minutesDiff} minutes`;
          }else {
            masterClass.startingSoonTime = "Class has started";
          }

          // masterClass.startingSoonTime =
          //   hoursDiff < 24 && minutesDiff < 60
          //     ? `Starting in ${hoursDiff} hours`
          //     : minutesDiff > 0
          //     ? `Starting in ${minutesDiff} minutes`
          //     : "Class has started";
        }}else{
          masterClass.startingSoonTime = "Coming Soon";
        }
     
      // console.log("masterclass",masterClass);
    });
  }
  

  copyCode(code: string,index): void {
    navigator.clipboard.writeText(code).then(
      () => {
       
        this.codeCopied[index] = true;

          console.log('Coupon code copied to clipboard!',code);
      },
      (err) => {
        console.error('Failed to copy: ', err);
      }
    );
  }

  maskCouponCode(code: string): string {
    if (!code || code.length <= 2) return code; // Ensure the code has enough characters
    const visiblePart = code.slice(0, 2); // First two characters
    const maskedPart = '*'.repeat(code.length - 2); // Replace the rest with stars
    return `${visiblePart}${maskedPart}`;
  }

  navigateTo(type,redeemNowLink){
    if(type == "redeemNow"){
      window.open(redeemNowLink, '_blank');    
  }
  }
  handleUserClick(type){
    if (this.user.status !== 0 && this.user.type == 'Listener') {
      // this.global.trackEvent('Distribute Audio', 'Landing-Navigation-CTA-not-Artist', type);
      this.dialog.openUpgradeAccountDialog(type);
    } else if (!this.user.isEmailVerified && this.user.status > 0 && this.user.type != 'Listener') {
      // this.global.trackEvent('Distribute Audio', 'Landing-Navigation-CTA-email-not-verify', type);
      console.log("email verified",this.user.isEmailVerified);
      this.dialog.openVerifyEmailDialog()
    } else if (this.user.status == 0) {
      // this.global.trackEvent('Distribute Audio', 'Landing-Audio-Navigation-CTA-not-login', type);
      this.dialog.openLoginDialog(1, '', 'masterclass', 'pro-perks');
    }else if  (this.user.isProMember ==0 || this.user.isProMember ==2) {
      this.dialog.openSubscriptionDialog();
    }
  }

}
